import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { crmConstants } from '..';

export function useGoogleSheetsLogOut() {
  const qc = useQueryClient();

  const { data, ...arg } = useMutation(
    async () => {
      const { data } = await $api.post('/v1/crm/drive/log-out');

      return data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([crmConstants.queryKeys.GOOGLE_SHEETS_ACCOUNT])
      },
      onError: baseErrorHandler
    }
  );

  return { data, ...arg };
}
